<template>
    <div style="margin-top: 100px;">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center" style="margin-bottom: 20px;">
                    <h2> {{ $route.name }} </h2>
                </div>
                <div class="col-md-6">
                    <!-- <input type="text" aria-label="test" style="width: 100%;"> -->
                </div>
                <div class="col-md-6">
                    <!-- <input type="text" placeholder="Pencarian" style="width: 100%;"> -->
                    <input v-model="cari" class="form-control" @keyup="getView" placeholder="Pencarian">
                </div>
            </div>

            <div class="row" style="margin-top: 20px; margin-bottom: 200px;">
                <div class="col-12">
 
                    <table style="width: 100%;">
                        <thead>
                            <tr class="" style="background-color: #14176c;">
                                <td style="padding: 10px;" class="text-center text-white">No</td>
                                <td style="padding: 10px;" class="text-white">Nama Dokumen</td>
                                <td style="padding: 10px;" class="text-white">Tanggal</td>
                                <td style="padding: 10px;" class="text-white">Act</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in list_data" :key="index">
                                <td style="padding: 5px;"  class="text-center">{{index+1}}.</td>
                                <td style="padding: 5px;" >{{item.judul}}</td>
                                <td style="padding: 5px;" >{{UMUM.tglConvert(item.createAt).tgl}}</td>
                                <td style="padding: 5px;" > <a :href="$store.state.UPLOADS+item.file" target="_blank">Lihat</a>  </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>

        </div>
        
    </div>
</template>

<script>
import UMUM from "../../library/umum"

export default {
    data() {
        return {
            UMUM:UMUM,
            list_data:[],
            jml_data:0,
            kategori:'Peraturan Bupati',
            cari:'',
            data_ke:1,
        }
    },
    methods: {
 
    getView() { 
        fetch(this.$store.state.URL.peraturan + 'view', {
            method: "POST",
            headers: {
            "content-type": "application/json", 
            }, 
            body:JSON.stringify(
                {
                data_ke         :   this.data_ke,
                cari_value      :   this.cari, 
                kategori        :   this.kategori
            }
            )
        })
        .then(res => res.json())
        .then(res_data => { 
            this.list_data  = res_data.data  
            this.jml_data   = res_data.jml_data  
            console.log(res_data); 
        });     
    },        
    },
    mounted() {
        this.getView()
        
    },
}
</script>

<style scoped>
    tr:nth-child(even) {background-color: #f2f2f2;}

</style>